var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Nav-Tray",
    transform: "translate(-1149.000000, -22.000000)",
    fill: "#05070B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Tray",
    transform: "translate(853.000000, -61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(296.167137, 83.396309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.924790642,1.20846268 C1.8096069,0.323646424 3.24921612,0.323345528 4.13433328,1.20846268 L4.13433328,1.20846268 L8.15805056,5.23273765 L11.8573535,1.53442386 C12.7003223,0.691455145 14.0462589,0.651613992 14.9368694,1.41406864 L15.0669263,1.53445395 C15.9517425,2.41927021 15.9520434,3.85887943 15.0669263,4.74399659 L15.0669263,4.74399659 L11.3680506,8.44173765 L15.0468565,12.1209859 C15.8898538,12.9639832 15.9296691,14.309894 15.1672119,15.2005019 L15.0468264,15.3305586 C14.1620101,16.2153749 12.722431,16.2157058 11.8372837,15.3305586 L11.8372837,15.3305586 L8.15805056,11.6517376 L4.15440307,15.6565198 C3.3114057,16.4995172 1.96549496,16.5393324 1.074887,15.7768752 L0.944830349,15.6564897 C0.0600140934,14.7716734 0.0596831072,13.3320943 0.944830349,12.4469471 L0.944830349,12.4469471 L4.94905056,8.44173765 L0.924760552,4.4180354 C0.081791836,3.57506669 0.0419506827,2.22913002 0.80440533,1.33851952 Z",
    id: "close"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b91cba19683d0e528cedc39ef4ebc3ed.svg";
export { ForwardRef as ReactComponent };